<template>
    <el-dialog
          id="progressDialog"
          v-model="dialogVisible"
          title="Loading"
          width="500"
          height="400"
          ref="progressDialog"
          class="progressDialog"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :before-close="cancelFun"
        >
        <el-progress style="height: 30px;width:100%"  :percentage="progress" :color="customColorMethod"></el-progress>
        <template #footer>
              <el-button type="primary" @click="cancelFun" style="--el-color-primary:#FEAA4C;color:#ffffff;background-color: #FEAA4C;border-color:#FEAA4C">
                cancel
              </el-button>
        </template>
    </el-dialog>
</template>

<script>
export default {
  props: {
    progressVisible: {
      type: Boolean,
      default: false
    },
    progressdata: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      progress: 0,
      isPlaying: false,
      isCompleted: false,
      dialogVisible: false, // this.$store.state.progressflag,
      customColorMethod: '#00A1AE'
    }
  },
  beforeUnmount () {
    this.$store.state.progressflag = false
  },
  watch: {
    progressVisible (newval, oldval) {
      if (!newval) {
        this.finish()
      }
      this.dialogVisible = newval
    },
    progressdata (newval, oldval) {
      this.progress = newval
    }

  },
  mounted () {
    this.dialogVisible = this.progressVisible
    this.progress = this.progressdata
    // this.start();
    console.log(this.progressVisible)
  },
  methods: {
    cancelFun () {
      //  取消接口请求
      this.$emit('cancelFun', '/file/eveFC')
      this.dialogVisible = false
      this.$store.state.progressflag = false
    },
    start () {
      this.isPlaying = true
      this.animateProgress(90)
        .then(() => {
          if (!this.isCompleted) {
            this.animateProgress(100)
          }
        })
        .catch((error) => {
          console.error('Progress error', error)
        })
    },
    animateProgress (target) {
      return new Promise((resolve, reject) => {
        const start = this.progress
        const end = target
        const duration = (target - start) * 150

        const doAnimation = () => {
          const elapsed = Date.now() - startTime
          const progress = Math.min(elapsed / duration, 1)

          this.progress = parseInt(start + ((end - start) * progress))
          // console.log(this.progress)
          if (progress === 1) {
            resolve()
          } else if (this.isCompleted) {
            resolve()
          } else {
            requestAnimationFrame(doAnimation)
          }
        }

        const startTime = Date.now()
        requestAnimationFrame(doAnimation)
      })
    },
    finish () {
      this.isCompleted = true
      this.progress = 100
    }
  }
}
</script>

<style  lang="less">
.progressDialog{
    .el-dialog__header{
    text-align: left!important;;
   }
}

</style>
